// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","255":"6763fea0","453":"component---src-pages-404-tsx","970":"component---src-pages-about-tsx"}[chunkId] + "-" + {"245":"85503b40739a8e9d861b","255":"6f2d23e4968126301786","453":"cb11713939ad4b9fa337","970":"4be33a2f436c23a6b474"}[chunkId] + ".js";
};